import { Flex, Tooltip } from 'antd';

import { Icon } from '../Icon';

import { TooltipIconWrapper } from './TableColumnWithTooltip.styles';

type Props = {
  title: string;
  tooltip: string;
};

export const TableColumnWithTooltip: React.FC<Props> = ({ title, tooltip }) => {
  return (
    <Flex align="center" gap={10}>
      <span>{title}</span>

      <Tooltip title={tooltip}>
        <TooltipIconWrapper>
          <Icon i="InformationFilled" />
        </TooltipIconWrapper>
      </Tooltip>
    </Flex>
  );
};
